module.exports = __webpack_public_path__ + "img/zhibo1.5637fd29.png";